import React, { Component } from 'react';
import AuthMiddleware from '../../store/middleware/authMiddleware';
import AuthActions from '../../store/actions/authActions';
import { connect } from 'react-redux';
// import * as firebase from 'firebase';
import Button from '@material-ui/core/Button';
import RouteActions from '../../store/actions/routeActions';
import { Link } from 'react-router-dom';

import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import CircularProgress from '@material-ui/core/CircularProgress';
import Images from "../../config/images";
import PiaicLogo from "../../assets/images/PiaicLogo.svg";
import './signin.css'
import K2 from '../../assets/images/K2.png';
import mountains from '../../assets/images/Group4.svg';
import SlashRouteAction from '../../store/actions/slashRouteAction';
import panacloudLogo from '../../assets/images/panacloudLogo.png';

class SignIn extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // email: '',
            // password: '',
            loader: false,
            panaCloudId: "",
            popupError1: false,
            popupError2: false,
            popupError3: false,
            panaCloudIdPopup: false,
        };
        props.routes(props.history);
    }

    componentWillMount() {
        this.props.setOnSlashRoute(true);
        let sessionStorageUser = JSON.parse(sessionStorage.getItem('sessionStorageUser'))
        if(sessionStorageUser){
            sessionStorage.setItem("token", sessionStorageUser.pc_access_token)
            this.props.history.push(`/home/${sessionStorage.getItem('panaCloudId')}`)
        }
    }
    updatePanaCloudId() {
        if (this.state.panaCloudId) {
            const panaCLoudIdTest = new RegExp("^[a-zA-Z][A-Za-z0-9_]*$");
            if (panaCLoudIdTest.test(this.state.panaCloudId)) {

                let data = {
                    id: this.props.user._id,
                    panaCloud_id: this.state.panaCloudId
                }
                this.props.updateprofile(data)
            }
            else {
                this.setState({
                    popupError1: true
                })
            }
        }
        else {
            this.setState({
                popupError3: true
            })
        }
    }
    componentWillUnmount() {
        this.props.setOnSlashRoute(false);
    }
    componentWillReceiveProps(nextprops) {
        if (nextprops.user) {
            var con1 = /^[^0-9_]/.test(nextprops.user.panacloudid);
            var con2 = !(/\W/.test(nextprops.user.panacloudid));
            if (con1 === con2) {
                this.props.history.replace(`/home/${nextprops.user.panacloudid}`);
            }
            else {
                this.popupOpen()
            }
        }
        if (nextprops.error) {
            this.setState({
                loader: false
            })
        }
        
        if (nextprops.update_error) {
            this.setState({
                popupError2: true,
            })
        }
    }

    popupOpen = () => {
        this.setState({ panaCloudIdPopup : true });
    };

    popupClose = () => {
        this.setState({ panaCloudIdPopup : false });
    };

    render() {
        const { push } = this.props.history;
        return (
            <div> {this.props.loader ?
                <div style={{ flexDirection: "column", display: "flex", alignItems: "center", justifyContent: "center", height: "100vh" }}><CircularProgress size={100} thickness={3} style={{color : "#13a89e"}}/></div> :
                <div>
                    {/* <form> */}
                    {/* <fieldset className="Input"> */}
                    {/* <h2><strong>SignIn</strong></h2>
                        <input className="check" type="email" required="required" placeholder="Enter Your Email"
                            onChange={e => this.setState({ email: e.target.value })} />
                        <br /><br />
                        <input className="check" type="password" required="required" placeholder="Enter Your Password"
                            onChange={e => this.setState({ password: e.target.value })} />
                        <br /><br /><br />
                        <input className="sbtn" type="submit" value="Sign In" onClick={this.submission.bind(this)} />
                        <br /><br /><br /> */}
                    {/* </fieldset> */}
                    {/* </form> */}
                    {!this.state.panaCloudIdPopup ? 
                   ( 
                    <div className='containerLoginPage'>
                    {/* <div></div> */}
                    <div className='containerLoginPage-top'>
                        <img className='k2Logo' src={K2} />
                    </div>
                    <div className='containerLoginPage-middle'>
                        <div className='containerLoginPage-middle-box'>
                            <div>
                            <img src={PiaicLogo} />
                            </div>
                            <div className='containerLoginPage-middle-box-text1'>
                            <span>
                          Presidential Initiative
                        </span>
                        <span>for Artificial Inteligence and Computing</span>
                            </div>
                            <div>
                            <button onClick={() => push('/signin')}>
                          Lets get started
                        </button>
                            </div>
                            <div className='containerLoginPage-middle-box-text2'>
                            <span>
                          Online Quiz System
                        </span>
                            </div>
                        </div>
                    </div>
                    <div className='containerLoginPage-bottom'>
                                {/* <img className='mountainPicture' src={mountains} /> */}
                        <div class="copyright-cont d-flex">
                            <div class="copy-text">
                                <b>A Product of Panacloud</b>
                            </div>
                            <div class="footer-logo">
                                <div class="footer-panacloudlogo-cont">
                                    <a href="https://www.panacloud.ai/" className='footrLogoHrefA' target="_blank" rel="noopener noreferrer">
                                        <b>Powered by</b>
                                        <img alt="panacloudlogo" src={panacloudLogo} />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                  </div>
                    )
                    : ""}
                    
                    <div>
                        <div>
                            <Dialog
                                open={this.state.panaCloudIdPopup}
                                aria-labelledby="form-dialog-title"
                            >
                                <DialogTitle id="form-dialog-title">Select Your Unique PanaCloud ID</DialogTitle>
                                <DialogContent>
                                    <DialogContentText>* ID should not contain charaters other then letter, number and underscore</DialogContentText>
                                    <DialogContentText>* ID can not starts with underscore or number</DialogContentText>
                                    <DialogContentText>* ID can not contains spaces</DialogContentText>
                                    <DialogContentText>* Examples: jhon, jhon_12, jhon_smith</DialogContentText>
                                    <TextField
                                        autoFocus
                                        margin="dense"
                                        id="name"
                                        label="PanaCloud ID"
                                        type="text"
                                        fullWidth
                                        inputProps={{
                                            maxLength: 15
                                        }}
                                        value={this.state.panaCloudId} onChange={(text) => { this.setState({ panaCloudId: text.target.value, popupError1: false, popupError2: false, popupError3: false }), this.props.clearupdatestate() }}
                                    />
                                    <DialogContentText style={this.state.popupError1 ? { display: "block", color: 'red', fontSize: '12px' } : { display: "none" }}>* Invalid ID format, Please follow the instruction to create ID</DialogContentText>
                                    <DialogContentText style={this.state.popupError2 ? { display: "block", color: 'red', fontSize: '12px' } : { display: "none" }}>* PanaCloud ID already exists, Please select different ID</DialogContentText>
                                    <DialogContentText style={this.state.popupError3 ? { display: "block", color: 'red', fontSize: '12px' } : { display: "none" }}>* This ID is required</DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                <Link to={{pathname : '/signin'}}>
                                    <Button onClick={this.popupClose} color="primary">
                                        Submit
                                    </Button>
                                </Link>
                                </DialogActions>
                            </Dialog>
                        </div>
                    </div>
                </div>}
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        user: state.authReducer.user,
        error: state.authReducer.iserror,
        loader: state.authReducer.isLoading,
        update_error: state.authReducer.updateError,
        onSlashRoute: state.SlashRouteReducer.onSlashRoute,
        appHistory: state.routeReducer.appHistory,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        clearupdatestate: () => { dispatch(AuthActions.ClearUpdateState()) },
        updateprofile: (data) => { dispatch(AuthMiddleware.updateprofileMiddleware(data)) },
        routes : (history) => { dispatch(RouteActions.AppRoute(history))},
        setOnSlashRoute : (data) => { dispatch(SlashRouteAction.OnSlashRoute(data))},

        // signin: (email, password) => { dispatch(AuthMiddleware.manualSignInMiddleware(email, password)) }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SignIn);









// work new
                    // <div style={{ marginTop : "5.5%" }}>
                    //     <div style={{ height : "250px", background : "linear-gradient(-135deg, #13a89e 5px, transparent 0) 0 5px,linear-gradient(135deg, #13a89e 5px, #fff 0) 0 5px", backgroundColor : "#13a89e", backgroundPosition : "left bottom", backgroundRepeat : "repeat-x", backgroundSize : "10px 10px" }}>
                    //     <p style={{textShadow : "3px 3px 1px #4a4949", color : "#ffffff", fontWeight : "bold", fontSize : "50px", paddingTop : "50px", textAlign : "center"}}>Welcome to PanaCloud Guru</p></div>
                    //     <div style={{display : "flex", justifyContent : "space-evenly"}}>
                    //         <div style={{marginRight : "10px", marginTop : "70px"}}>
                    //             <div>
                    //                 <img src={Images.authorIcon} height="100" width="100" />
                    //                 <div>
                    //                     <h4 style={{fontSize : "18px", fontWeight : "500", lineHeight : "1.1"}}>Top Author's</h4>
                    //                 </div>
                    //             </div>
                    //         </div>
                    //         <div style={{marginRight : "10px", marginTop : "70px"}}>
                    //             <div>
                    //                 <img src={Images.groupIcon} height="100" width="100" />
                    //                 <div>
                    //                     <h4 style={{fontSize : "18px", fontWeight : "500", lineHeight : "1.1"}}>Top Group's</h4>
                    //                 </div>
                    //             </div>
                    //         </div>
                    //         <div style={{marginRight : "10px", marginTop : "70px"}}>
                    //             <div>
                    //                 <img src={Images.examIcon} height="100" width="100" />
                    //                 <div>
                    //                     <h4 style={{fontSize : "18px", fontWeight : "500", lineHeight : "1.1"}}>Top Exam's</h4>
                    //                 </div>
                    //             </div>
                    //         </div>
                    //     </div>
                    // </div>

// work new end


// sadfsd
// <div>
// <h1 style={{marginLeft:"3%",color:"blue"}}>K2</h1>
// <div style={{ display: "grid", justifyContent: "center" }}>
//   {" "}
//   <div
//     style={{
//       display: "grid",
//       justifyContent: "center",
//       width: "100%"
//     }}
//   >
//     <img
//       src={PiaicLogo}
//       style={{
//         display: "block",
//         marginLeft: "auto",
//         marginRight: "auto",
//         width: "30%"
//       }}
//     />
//     <span style={{ display: "grid", justifyContent: "center" }}>
//       Presidential Initiative
//     </span>
//     <span>for Artificial Inteligence and Computing</span>
//     <button
//       style={{
//         marginTop: "2%",
//         borderRadius: "5px",
//         backgroundColor: "blue",
//         height: "40px",
//         width: "100%",
//         border: "0px",
//         color: "white"
//       }}
//     >
//       Lets Get Started
//     </button>
//     <span style={{ fontSize: "40px", color: "rgb(140,140,140)" }}>
//       Online Quiz System
//     </span>
//   </div>
// </div>
// <Ktwo />
// </div>

// sdfsdfds


// WEBPACK FOOTER //
// ./src/container/SignIn/signin.js